import { EntityMetric } from '@/lib/enums';

const METRIC_LIST = [
  EntityMetric.BUDGET,
  EntityMetric.ALLOCATED_FTE,
  EntityMetric.FTE,
  EntityMetric.HOURS,
  EntityMetric.ACTIVITIES,
  EntityMetric.ACTIVITY_BUDGET,
  EntityMetric.COST,
  EntityMetric.MANAGERS,
  EntityMetric.AVERAGE_SPAN,
  EntityMetric.SPAN,
  EntityMetric.ROLES,
  EntityMetric.GROUPS,
];

const hasAverageSpan = ({ comparisonMetrics, scenarioMetrics }) => {
  const comparisonSpan = comparisonMetrics[EntityMetric.AVERAGE_SPAN];
  const scenarioSpan = scenarioMetrics[EntityMetric.AVERAGE_SPAN];

  if (!comparisonSpan && !scenarioSpan) {
    return;
  }

  return comparisonSpan !== scenarioSpan;
};

export default function summaryMetricList({
  comparisonMetrics,
  impactMetrics,
  scenarioMetrics,
  showAllocatedFTE,
  showBudget,
  showCost,
  showActivityBudget,
  showSpan,
}) {
  const metricList = [];
  if (!scenarioMetrics || !comparisonMetrics) {
    return metricList;
  }

  const showAverageSpan = hasAverageSpan({
    comparisonMetrics,
    scenarioMetrics,
  });

  METRIC_LIST.forEach((metric) => {
    if (!showAllocatedFTE && metric === EntityMetric.ALLOCATED_FTE) {
      return;
    }
    if (!showBudget && metric === EntityMetric.BUDGET) {
      return;
    }
    if (!showCost && metric === EntityMetric.COST) {
      return;
    }
    if (!showActivityBudget && metric === EntityMetric.ACTIVITY_BUDGET) {
      return;
    }
    if (!showSpan && metric === EntityMetric.SPAN) {
      return;
    }
    if (metric === EntityMetric.BUDGET) {
      metricList.push(metric);
      return;
    }
    if (metric === EntityMetric.ACTIVITY_BUDGET) {
      metricList.push(metric);
      return;
    }

    if (metric === EntityMetric.SPAN && showAverageSpan) {
      return;
    }

    if (comparisonMetrics[metric] !== scenarioMetrics[metric]) {
      metricList.push(metric);
    }
  });

  return metricList;
}
